import React, { useState } from 'react';
import BaseTableNew from 'components/atoms/base-table/new';
import { useTranslation } from 'react-i18next';
import BaseModal from 'components/atoms/base-modal';
import { useGetClinicInvoices } from 'infrastructure/hooks/clinic-invoices/use-get-clinic-invoices';
import FadeAnimation from 'components/atoms/base-animations/fade';

import { columns } from './cols';
import s from './styles.module.scss';
import ClinicInvoiceEditForm from '../invoice-edit-form';

import type { ClinicInvoice } from 'infrastructure/classes/clinic-invoice/clinic-invoice';
import type { IBaseComponentProps } from 'infrastructure/interfaces';

interface IProps extends IBaseComponentProps {
  clinicGuid: string;
  isEdit: boolean;
}

const ClinicInvoicesTable: React.FC<IProps> = (props) => {
  const { clinicGuid, isEdit } = props;

  const { t } = useTranslation();

  const [invoiceToEdit, setInvoiceToEdit] = useState<
    undefined | ClinicInvoice
  >();

  const modalTitle = `${t('labels.editCode')} - ${invoiceToEdit?.code}`;

  const { items, loading } = useGetClinicInvoices({
    clinicGuid,
  });

  const onEdit = (rec: ClinicInvoice) => {
    setInvoiceToEdit(rec);
  };

  const onClose = () => {
    setInvoiceToEdit(undefined);
  };

  const onSave = (rec: ClinicInvoice) => {
    if (invoiceToEdit) {
      invoiceToEdit.saveChanges(rec);
    }
    setInvoiceToEdit(undefined);
  };

  return (
    <div>
      <p className={s.title}>{t('labels.invoicingProducts')}</p>
      <FadeAnimation uniqueKey={`${isEdit}`}>
        <BaseTableNew
          loading={loading}
          columns={columns({ isEdit, onEdit, onSave })}
          bordered
          items={items}
        />
      </FadeAnimation>

      <BaseModal title={modalTitle} open={!!invoiceToEdit} onCancel={onClose}>
        {invoiceToEdit && (
          <ClinicInvoiceEditForm
            data={invoiceToEdit}
            onCancel={onClose}
            onSave={onSave}
          />
        )}
      </BaseModal>
    </div>
  );
};

export default ClinicInvoicesTable;
